import { render, staticRenderFns } from "./ViewCustomer.vue?vue&type=template&id=1141e0b0&scoped=true&"
import script from "./ViewCustomer.vue?vue&type=script&lang=js&"
export * from "./ViewCustomer.vue?vue&type=script&lang=js&"
import style0 from "./ViewCustomer.vue?vue&type=style&index=0&id=1141e0b0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1141e0b0",
  null
  
)

export default component.exports